var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.000976562 9.9999C0.000976562 4.47724 4.47809 0 10.0007 0C15.5234 0 20.0008 4.47724 20.0008 9.9999C20.0008 15.5224 15.5234 20 10.0007 20C4.47809 20 0.000976562 15.5224 0.000976562 9.9999ZM16.53 7.58079L10.0009 3.50944L3.4718 7.58079H16.53ZM15.4285 15.2644C16.0814 15.2644 16.6113 14.7353 16.6113 14.0822V7.83985C16.6113 7.77064 16.6043 7.70363 16.5928 7.63765L10.3546 11.5275C10.1349 11.6648 9.86533 11.6635 9.64782 11.5275L3.40965 7.63765C3.39817 7.70363 3.39111 7.77078 3.39111 7.83985V14.0822C3.39111 14.7352 3.92028 15.2644 4.57331 15.2644H15.4285Z","fill":"white","fillOpacity":"0.65"}));
}

Email.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Email;

Email.default = Email;
